import React from "react";
import './styles/App.css';
import Main from './components/Main';

function App() {
  return (
    <Main />
  );
}

export default App;
